var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26 10.147C3.98495 12.2526 3.82105 14.3712 3.769 16.494C6.64779 17.6966 9.40416 19.1734 12 20.904C14.5962 19.1733 17.3529 17.6965 20.232 16.494C20.1799 14.3712 20.016 12.2526 19.741 10.147M19.741 10.147C20.616 9.85301 21.503 9.58101 22.399 9.33301C19.1356 7.04525 15.652 5.08889 12 3.49301C8.34799 5.08923 4.8644 7.04592 1.601 9.33401C2.49428 9.58061 3.38062 9.85171 4.259 10.147C6.92766 11.0441 9.51694 12.162 12 13.489C14.4827 12.1621 17.0727 11.0442 19.741 10.147ZM6.75 15C6.94891 15 7.13968 14.921 7.28033 14.7803C7.42098 14.6397 7.5 14.4489 7.5 14.25C7.5 14.0511 7.42098 13.8603 7.28033 13.7197C7.13968 13.579 6.94891 13.5 6.75 13.5C6.55109 13.5 6.36032 13.579 6.21967 13.7197C6.07902 13.8603 6 14.0511 6 14.25C6 14.4489 6.07902 14.6397 6.21967 14.7803C6.36032 14.921 6.55109 15 6.75 15ZM6.75 15V11.325C8.44674 10.2703 10.1993 9.30828 12 8.44301M4.993 19.993C5.55097 19.4364 5.99344 18.775 6.29497 18.0469C6.59649 17.3187 6.75113 16.5381 6.75 15.75V14.25",
    stroke: "#8E9AB6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.8ab98990e9f7b52efd1f8e28a0b5d640.svg";
export { ForwardRef as ReactComponent };